module.exports = __webpack_public_path__ + "img/logo_sm_light.92a0ab7e.png";